import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["customFormFields"];
// @ts-expect-error untyped import
import { handleActions } from 'flux-actions';
import { Map as ImmutableMap } from 'immutable';
import FormState from 'MeetingsLib/models/FormState';
// @ts-expect-error untyped import
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
const initialState = new FormState();
export default handleActions({
  [ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED](state, action) {
    const {
      bookInfo: {
        formPrefills
      },
      customFormFields: configuredCustomFormFields
    } = action.payload;
    state = state || new FormState();
    // merge fields from query params with fields saved on link
    // don't filter out fields that are not saved on link
    // support "hidden field" submissions SMMC-1144
    let _state$toObject = state.toObject(),
      {
        customFormFields
      } = _state$toObject,
      defaultFormFields = _objectWithoutPropertiesLoose(_state$toObject, _excluded);
    // @ts-expect-error fix type
    defaultFormFields = ImmutableMap(defaultFormFields).map((field, key) => field || formPrefills.get(key));
    customFormFields = configuredCustomFormFields
    // @ts-expect-error fix type
    .map((field, key) => formPrefills.getIn(['customFormFields', key], field)).merge(state.customFormFields);
    return state.merge(defaultFormFields).set('customFormFields', customFormFields).set('originalFormState', state.delete('originalFormState'));
  },
  [ActionTypes.PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED](state, action) {
    const {
      bookInfo: {
        formPrefills
      },
      customFormFields: configuredCustomFormFields
    } = action.payload;
    const {
      firstName,
      lastName,
      customFormFields
    } =
    // @ts-expect-error fix type
    state.originalFormState.toObject();
    return state.email !== formPrefills.email ? FormState.from({
      firstName,
      lastName,
      email: state.email,
      customFormFields: configuredCustomFormFields.merge(customFormFields)
    }) : state;
  },
  [ActionTypes.SET_EMAIL_FORM](state, action) {
    return state.set('email', action.payload);
  },
  [ActionTypes.RESET_EMAIL_FORM](state) {
    return state.set('email', '');
  },
  [ActionTypes.SET_FORM_FIELD](state, action) {
    const {
      fieldName,
      fieldValue
    } = action.payload;
    if (state.has(fieldName)) {
      return state.set(fieldName, fieldValue);
    } else if (state.hasIn(['customFormFields', fieldName])) {
      return state.setIn(['customFormFields', fieldName], fieldValue);
    }
    return state;
  }
}, initialState);